<template>
	<section>
		<mu-row class="sys_title">
			<mu-col width="15" tablet="15" desktop="15">&nbsp;</mu-col>
			<mu-col width="70" tablet="70" desktop="70" class="sys_title">
				<mu-row>
					<mu-col span="5">
						<mu-chip backgroundColor="rgba(255, 255, 255, 1)" style="marginTop:-8px">
							<mu-avatar backgroundColor="rgba(0,0,0,0)" :size="70"><img src="/static/img/logo.png" /></mu-avatar>
							<span style="font-size:2.2em;font-weight:bolder;color:#505050;">智慧济南时空大数据平台(公众版)</span>
						</mu-chip>
					</mu-col>
					<mu-col span="3"></mu-col>
					<mu-col span="4">
						<div backgroundColor="rgba(255, 255, 255, 1)" style=" color:#2363B5;  margin-top: -25px;padding:0 0;cursor: default">
							<!--     <mu-avatar color="indigo" :size="20">
            <mu-icon value="account_circle"  ></mu-icon>
          </mu-avatar> -->
							<template v-if="userInfo">
								<div class="user-detail">
									<span class="user-name" @click="openNewWindow(UserCenterLocation + '#0')">{{ username }}&nbsp;&nbsp;</span>
									|
									<span @click="openNewWindow(UserCenterLocation + '#1')">
										<span>
											&nbsp;我的消息&nbsp;
											<span class="user-count" v-if="userMsgCount">{{ '(' + userMsgCount + ')' }}&nbsp;</span>
										</span>
									</span>
									<!-- |
									<span @click="loginHelp">&nbsp;帮助中心</span> -->
									|
									<span @click="logout">&nbsp;注销登录</span>
								</div>
							</template>
							<template v-else>
								<div class="user-detail">
									<span @click="userLogin">&nbsp;登录</span>
									|
									<span @click="userRegister">&nbsp;注册</span>
								</div>
							</template>
						</div>

						<div style="margin-left:20px;margin-top: 10px;">
							<!-- <el-input ref="input" placeholder="请输入资源名称查询" @keyup.enter.native="">
								<el-button slot="append" color="#fff" class="excBtn" @click="search">搜索</el-button>
							</el-input> -->
						</div>
					</mu-col>
				</mu-row>
			</mu-col>
			<mu-col width="15" tablet="15" desktop="15">&nbsp;</mu-col>
		</mu-row>
		<mu-row class="main_nav">
			<mu-col width="15" tablet="15" desktop="15">&nbsp;</mu-col>
			<mu-col width="70" tablet="70" desktop="70">
				<mu-tabs value="tab0" class="main_nav">
					<template v-for="(item, index) in modules">
						<mu-tab :title="item.name" :key="item.pkid" :index="item.pkid" @click="openNewWindow(item.href)" :value="setValue(index)"></mu-tab>
					</template>
				</mu-tabs>
			</mu-col>
			<mu-col width="15" tablet="15" desktop="15">&nbsp;</mu-col>
		</mu-row>
		<template>
			<div class="block">
				<el-carousel height="517px">
					<el-carousel-item><img src="/static/img/slider1.jpg" /></el-carousel-item>
					<el-carousel-item><img src="/static/img/slider2.jpg" /></el-carousel-item>
					<el-carousel-item><img src="/static/img/slider3.jpg" /></el-carousel-item>
				</el-carousel>
			</div>
		</template>
		<mu-row class="sys_pingtai">
			<mu-col width="15" tablet="15" desktop="15">&nbsp;</mu-col>
			<mu-col width="70" tablet="70" desktop="70">
				<mu-row class="banner_nav_col navigation" id="nav_col_img">
					<ul class="ali-main-special" id="J-ali-main-specail" style="justify-content: space-around;display: flex;">
						<li class="">
							<div class="media center-block">
								<div class="media-left">
									<a href="/map" class="cloud1" target="_blank">
										<img src="/static/img/00.png" style="width:110px;" alt="" class="media-object bg-item bg-normal"
										 data-holder-rendered="true" />

										<img src="/static/img/00_0.png" style="width:110px;" alt="" class=" media-object bg-item bg-hover"
										 data-holder-rendered="true" />
									</a>
								</div>
								<div class="media-body">
									<a class="cloud1" href="/map" target="_blank">
										<h4 class="media-heading">电子地图服务</h4>
										<p style="color:#808080;">满足一体化云平台</p>
									</a>
								</div>
							</div>
						</li>
						<li class="">
							<div class="media center-block">
								<div class="media-left">
									<a href="javacript:void(0);" class="data" @click="scrollHtml('jcsj')">
										<img src="/static/img/11.png" style="width:110px;" alt="" class="media-object bg-item bg-normal"
										 data-holder-rendered="true" />
										<img src="/static/img/11_1.png" style="width:110px;" alt="" class="media-object bg-item bg-hover"
										 data-holder-rendered="true" />
									</a>
								</div>
								<div class="media-body">
									<a href="javacript:void(0);" class="data" @click="scrollHtml('jcsj')">
										<h4 class="media-heading">基础数据服务</h4>
										<p style="color:#808080;">满足一体化云平台</p>
									</a>
								</div>
							</div>
						</li>
						<!-- <li class="">
							<div class="media center-block">
								<div class="media-left">
									<a href="javacript:void(0);" class="function" @click="scrollHtml('jcgn')">
										<img src="/static/img/22.png" style="width:110px;" alt="" class=" media-object bg-item bg-normal"
										 data-holder-rendered="true" />

										<img src="/static/img/22_2.png" style="width:110px;" alt="" class="media-object bg-item bg-hover"
										 data-holder-rendered="true" />
									</a>
								</div>
								<div class="media-body">
									<a href="javacript:void(0);" class="function" @click="scrollHtml('jcgn')">
										<h4 class="media-heading">基础功能服务</h4>
										<p style="color:#808080;">满足一体化云平台</p>
									</a>
								</div>
								<a href="#" class="function"></a>
							</div>
						</li> -->

						<!-- <li class="">
							<div class="media center-block">
								<div class="media-left">
									<a href="javacript:void(0);" class="application" @click="scrollHtml('ptyy')">
										<img src="/static/img/33.png" style="width:110px;" alt="" class=" media-object bg-item bg-normal"
										 data-holder-rendered="true" />
										<img src="/static/img/33_3.png" style="width:110px;" alt="" class=" media-object bg-item bg-hover"
										 data-holder-rendered="true" />
									</a>
								</div>
								<div class="media-body">
									<a href="javacript:void(0);" class="application" @click="scrollHtml('ptyy')">
										<h4 class="media-heading">平台应用服务</h4>
										<p style="color:#808080;">满足一体化云平台</p>
									</a>
								</div>
							</div>
						</li>
						<li class="">
							<div class="media center-block">
								<div class="media-left">
									<a href="javacript:void(0);" class="application" @click="scrollHtml('sjdt')">
										<img src="/static/img/44.png" style="width:110px;" alt="" class=" media-object bg-item bg-normal"
										 data-holder-rendered="true" />
										<img src="/static/img/44_4.png" style="width:110px;" alt="" class=" media-object bg-item bg-hover"
										 data-holder-rendered="true" />
									</a>
								</div>
								<div class="media-body">
									<a href="javacript:void(0);" class="application" @click="scrollHtml('sjdt')">
										<h4 class="media-heading">手机地图服务</h4>
										<p style="color:#808080;">满足一体化云平台</p>
									</a>
								</div>
							</div>
						</li> -->
					</ul>
				</mu-row>
			</mu-col>
			<mu-col width="15" tablet="15" desktop="15">&nbsp;</mu-col>
		</mu-row>
		<div style="background: url(/static/img/bg3.png) no-repeat  center;">
			<el-divider content-position="center">基础数据服务</el-divider>
			<div id="jcsj" style="    margin-left: 15%;
width: 70%;
text-align: center;font-size: 16px;">
				一体化公共服务平台遵循开放地理空间联盟（OGC）服务标准，提供了包括WMS（Web地图服务）、WFS（Web要素服务）、WFS-G（地名地址服务）等，以及KML、街景数据服务、全景数据服务和与平台对接系统的相关专题服务
			</div>

			<mu-paper class="no_shadow ">
				<mu-row class="bg_h">
					<mu-col width="15" tablet="15" desktop="15">&nbsp;</mu-col>
					<mu-col width="70" tablet="70" desktop="70" class="banner_nav_col">
						<mu-tabs :value="active" center class="service_nav" @change="changeTabs">
							<template v-for="(item, index) in dataThemes">
								<mu-tab :title="item.name" :value="item.theme" class="mu-tab-link-1"><img :src="item.imgUrl" width="25" height="25" /></mu-tab>
							</template>
						</mu-tabs>
						<mu-paper class="service_tabs_content">
							<mu-list>
								<template v-for="(item, index) in servicesInfos">
									<mu-paper class="service_item" :title="item.resourceName" :key="item.pkid" :index="item.pkid" :value="setValue(index)">
										<div style="width: 100%;height: 100%;" @click="openNewWindow(item,'devcenter')">
											<mu-card-media><img :src="returnImgUrl(item.resourceId)" height="240" onerror="returnErrorUrl" /></mu-card-media>
											<mu-card-text @click="openNewWindow(item.href)">
												<div class="service-title" title="item.resourceName">{{ item.resourceName }}</div>
												<div class="pub_dw">
													所属部门：
													<span>{{ item.metadepname }}</span>
												</div>
												<div class="pub_dw">
													专题类型：
													<span>{{ item.special.value }}</span>
												</div>
												<div class="pub_dw">
													发布时间：
													<span>{{ item.sequenceStart }}</span>
												</div>
											</mu-card-text>
										</div>
									</mu-paper>
								</template>
							</mu-list>
						</mu-paper>
					</mu-col>
					<mu-col width="15" tablet="15" desktop="15">&nbsp;</mu-col>
				</mu-row>
			</mu-paper>
<!--
			<el-divider content-position="center">基础功能服务</el-divider>
			<div id="jcgn" style="    margin-left: 15%;line-height: 40px;
width: 70%;
text-align: center;font-size: 16px;">
				一体化公共服务平台提供用于辅助应用程序执行的各种几何计算能力和基于网络的地理处理分析功能服务，为用户提供了一个在线地理处理的工具箱
			</div> -->
			<!-- <mu-row style="height: 200px;">
				<mu-col width="15" tablet="15" desktop="15">&nbsp;</mu-col>
				<mu-col width="70" tablet="70" desktop="70">
					<mu-row class="banner_nav_col" id="nav_4_img">
						<template v-for="(item, index) in jichuGN">
							<mu-col width="25" tablet="25" desktop="25" class="card-back-url" :style="returnStyle(item.backUrl)">
								<a href="javacript:void(0);" @click="openWindow(item.url,item.name)"> -->
									<!-- :href="item.url"  -->
									<!-- <mu-card-header :title="item.name" :subTitle="item.subtitle">
										<mu-avatar backgroundColor="#ffffff" :size="60" slot="avatar"><img :src="item.imgUrl" /></mu-avatar>
									</mu-card-header>
								</a>
							</mu-col>
						</template>
					</mu-row>
				</mu-col>
				<mu-col width="15" tablet="15" desktop="15">&nbsp;</mu-col>
			</mu-row> -->

			<!-- <el-divider content-position="center">平台应用服务</el-divider>
			<div id="ptyy" style="margin-left: 15%;line-height: 50px;width: 70%;text-align: center;font-size: 16px;">
				时空大数据平台应用体系，汇集了平台中基于数据服务衍生出的二次应用成果，这些应用成果或具有典型示范作用，或能彰显业务价值，或权威可靠，内容覆盖政务办、各行业专题、类型包含智慧水务、地理国情监测、各种应用程序等。
			</div>


			<div style="width: 100%;">
				<div style="width: 70%;overflow: hidden;border:1px solid #ccc;text-align: center;margin:0 auto;height: 200px;">
					<div id="cardContainer1" class="slideInRight animated" style="width:4800px;padding: 10px;">
						<template v-for="(item, index) in Themes2">

							<div style="float:left;margin-right:60px;">
								<a href="javacript:void(0);" @click="openNewWindow(item.url,item.name)" v-on:mouseover="" v-on:mouseout="">

									<div style="position: relative;"><span class="card_text">{{item.name}}</span><img :src="item.imgUrl" width="400"
										 height="180" /></div>
								</a>
							</div>

						</template>
					</div>
				</div>
			</div>
			<h2 style="text-align: center;width: 100%;font-weight: 500;margin-top: 30px;font-size: 30px;">典型应用</h2>
			<mu-row>
				<mu-col width="15" tablet="15" desktop="15">&nbsp;</mu-col>
				<mu-col width="70" tablet="70" desktop="70">
					<div style=" float: right;font-size: 20px;font-weight: 900;color:#286fab "><a href="" @click="openNewWindow('#/yymore')">更多</a></div>
				</mu-col>
				<mu-col width="15" tablet="15" desktop="15">&nbsp;</mu-col>
			</mu-row>
			<div style="width: 100%;">
				<div style="width: 70%;overflow: hidden;text-align: center;margin:0 auto;height: 200px;">
					<div id="cardContainer" class="slideInRight animated" style="width:4800px;">
						<template v-for="(item, index) in duijieyingyong">
							<div id="cards" style="float:left;margin-right:20px;">
								<a href="javacript:void(0);" @click="openNewWindow(item.url,item.name)" v-on:mouseover="" v-on:mouseout="">
									<div style="position: relative;">
										<span class="card_text">{{item.name}}</span>
										<img :src="item.imgUrl" width="320" height="180" /></div>
								</a>
							</div>
						</template>
					</div>
				</div>
			</div> -->

			<!-- <mu-row>
				<mu-col width="15" tablet="15" desktop="15">&nbsp;</mu-col>


					<mu-col width="70" tablet="70" desktop="70"> -->
			<!-- 	<div class="case">
					<template v-for="(item, index) in Themes3">
						<mu-list-item :ripple="false">
							<a href="javascript:void(0);" target="_blank" @click="openNewWindow(item.url)" >

									<div style="width: 50%;float: left;"><img :src="item.imgUrl" width="100%" height="90" /></div>

									<div style="width: 50%;height:90px;float: left;font-size: 22px;font-weight: bold;text-align: center;  color: white;  line-height: 90px;    vertical-align: middle;background-color: #286fab">{{ item.name }}</div>

							</a>
						</mu-list-item>
					</template>
					</div> -->
			<!-- <div class="dianxing">
						<mu-grid-list class="gridlist-demo">
							<template v-for="(item, index) in Themes4">
								<a href="javascript:void(0);" target="_blank" @click="openNewWindow(item.url)" style="width: 49%;padding: 22px;">
									<div style="position: relative;border: #ded6d6 1px solid;padding: 10px;">
										<div style="width: 20%;height: 95px;"><img :src="item.imgUrl" width="80" /></div>
										<div style="position: absolute;left: 30%;top: 15%;font-size: 20px;color: #286fab;font-weight: bold;">{{ item.name }}</div>
										<div style="position: absolute;left: 30%;top: 50%;color: #c4cad0;">点击查看详情</div>
										<div style="position: absolute;right: 10%;bottom: 15%;"><img src="../../static/img/arrw.png"/></div>
									</div>
								</a>
							</template>
						</mu-grid-list>
						</div> -->
			<!-- </mu-col>

				<mu-col width="15" tablet="15" desktop="15">&nbsp;</mu-col>
			</mu-row> -->
		</div>
	<!-- 	<mu-row class="phone-background" id="sjdt">
			<mu-col width="45" tablet="45" desktop="45">&nbsp;</mu-col>
			<mu-col width="10" tablet="10" desktop="10" class="phone-title">手机地图</mu-col>
			<mu-col width="45" tablet="45" desktop="45">&nbsp;</mu-col>

			<mu-col width="15" tablet="15" desktop="15">&nbsp;</mu-col>
			<mu-col width="70" tablet="70" desktop="70">
				<mu-row class="banner_nav_col">
					<mu-col width="50" tablet="50" desktop="50" class="finger"></mu-col>

					<mu-col width="50" tablet="50" desktop="50" class="textdesc">
						<h5>丰富的POI/足不出户、吃喝玩乐一手掌控</h5>
						<ul>
							<li>省内最权威、最完整的海量地理空间数据，为用户提供完备的地图功能</li>
							<li>提供矢量和影像地图浏览、线路规划、离线浏览、实时定位</li>
							<li>自驾规划，方便您的出行</li>
						</ul>
						<div class="liaojiedesc" @click="openNewWindow('/nav/updatelog.html')">了解更多</div>
						<div class="erweima">
							<img src="/static/img/anzhuo.png" style="width: 75px;" />
							<img src="/static/img/ios.png" style="margin-left: 15px; width: 75px;" />
							<img src="/static/img/android.png" style="margin-left: 15px;" />
							<img src="/static/img/iphone.png" style="margin-left: 15px;" />
						</div>
					</mu-col>
				</mu-row>
			</mu-col>
			<mu-col width="15" tablet="15" desktop="15">&nbsp;</mu-col>
		</mu-row> -->
		<div class="foot">
			<div class="col-md-12 rows">
				<div class="footHrefOuter">
					<div class='imgConac' @click="toHref()">
						<img src="../../static/img/jiguan.png">
					</div>
					<div id="last" class="" style="text-align: center; line-height: 28px; height: auto !important; margin-top: 20px;float:right;width:80%;position: relative;right:211px;">
						<span style="">版权所有:济南市自然资源和规划局</span>
						<span>地址:济南市历下区龙鼎大道1号</span>
						<span>邮编：250099</span><br>
						<span>技术支持单位：北京超图软件股份有限公司</span>
						<span>网站标识码：3701000033</span><br>
						<span><a class = "a_v" href="https://beian.miit.gov.cn" target="_blank">鲁ICP备2024100113号-1</a></span>
						<span style="line-height: 20px;"><a class = "a_v" title="鲁公网安备 37010202700266" href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=37010202700266"  target="_blank" readlabel="" tabindex="0" ><img src="../../static/img/1912041428398372085.png" style="vertical-align: bottom;padding-bottom: 3px;"> 鲁公网安备 37010202700266 </a></span><br>
					</div>
					<div style="z-index: 999;display: inline-block;position: relative;left: 53%;top: 15px;">
						<span id='_span_jiucuo'>
							<img onclick="Link('3701000033')" style="margin:0;border:0;cursor: pointer;" src="../../static/img/jiucuo.png">
						</span>
					</div>
					<div style='float:left;width:100%;'>
						<p class="footHref3" style="background: rgb(204, 204, 204); font-size: 12px;">
							<span>
								建议分辨率为1920×1080分辨率，推荐浏览器为Chrome71
								<!-- <a href="../support/download/brow/chromedev_x64-v71.exe">（点击下载）</a> -->
							</span>
						</p>
					</div>
				</div>

			</div>
		</div>
	</section>
</template>
<script type="text/javascript">
	import axios from 'axios';
	import Cookies from 'js-cookie';

	import $ from 'jquery';
	import {
		getUserMessage,

		getTicket,
		getServiceTicketGeoesbengine,
		getServiceCall,
		deleteTGT,
	} from '@/apis/api';
	import {
		Geoesbmengine,
		Usercenter,
		Cas,
		Nav,
		Editmanager,
		Map,
		Webframe,
		dataThemesConfig,
		jichuGNConfig
	} from '@/config/app-config';
	axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
	axios.defaults.withCredentials = true;
	let host = APPCONFIG.IP,
		casLogout = Cas.location + '/logout';
	export default {
		components: {},
		data() {
			return {
				modules: [],
				dataThemes: dataThemesConfig,
				usershortname: '游客',
				userMsgCount: 0,
				active: dataThemesConfig[0].theme,
				servicesInfos: [],
				Themes2: [],
				duijieyingyong: [],
				Themes2Now: [],
				permisArray: [],
				Themes3: [],
				Themes4: [],
				jichuGN: jichuGNConfig,
				host: host,
				userid: '',
				userInfo: null,
				username: '游客',
				UserCenterLocation: Usercenter.location,
				EditManagerLocation: Editmanager.location,
				loginTextShow: true,
				supervisePoints: [],
				timer: "",
				nowTimes: 0
			};
		},
		created() {
			setInterval(this.getUserMessage, 20000);
		},
		watch: {
			active(val) {
				this.getServicesInfo(val);
			}
		},
		methods: {
			search() {
				alert('功能完善中...');
			},
			changeTabs(val) {
				this.active = val;
			},
			toHref(){
				window.open(APPCONFIG.dzjgUrl, '_blank');
			},
			returnAlert() {
				alert('功能完善中...');
			},
			openWindow(location, name) {
				// debugger
				if (this.userInfo) {
					window.open(location, '_blank');
				} else {
					// alert("暂无权限");
					this.$message.warning("请登录后再使用")
				}
			},
			openNewWindow(location, name) {
				if (name && name == "devcenter") {
					window.open('/devcenter/index.html?uuid=' + location.resourceId + '&resname=' + location.resourceName +
						'&resstate=' + location.resourceState.key + '&resstate=' + location.resPrivilegeState.key, '_blank');
					return;
				}

				if (name) {
					for (var i = 0; i < this.permisArray.length; i++) {
						if (this.permisArray[i].name == name) {
							// debugger
							flag = true;
							if (location.indexOf("8022") > -1) {
								let host8022 = window.location.protocol + "//" +(( window.location.host === "10.210.97.189:8080")? '10.210.97.189:8022':'172.16.100.81:18022');
								location = location.replace("https://10.210.97.189:8022", host8022);
							}
							window.open(location, '_blank');
							break;
						}
					}
					if (!flag) {
						alert("请登录后再使用");
					}
				} else {
					if (location.indexOf('no_no') > -1) {
						alert('功能完善中...');
					} else {
						window.open(location, '_blank');
					}
				}
			},
			setValue(index) {
				return 'tab' + index;
			},
			returnImgUrl(pkid) {
				return APPCONFIG.serviceImgUrl + pkid;
			},
			returnErrorUrl() {
				return APPCONFIG.host + '/skywebframe/images/404.png';
			},
			getUserMessage() {
				if (this.userInfo) {
					getUserMessage().then(res => {
						let result = res.data.resultInfo;
						if (result.success) {
							let count = result.data.sum;
							if (count > 99) {
								this.userMsgCount = '99+';
							} else {
								this.userMsgCount = count;
							}
						}
					});
				}
			},
			getMapModule(id) {
				let that = this;
				axios.get(APPCONFIG.GetMoudlesUrl + id + '.json').then(function(e) {
					if (e.data && e.data.data) {
						that.modules = e.data.data.modules[0].children[0].children;
					}
				});
			},
			scrollHtml(len) {
				var h = $(window).scrollTop(); //获取当前滚动条距离顶部的位置
				// $("html,body").animate({ scrollTop: h+len }, 800);//点击按钮向下移动800px，时间为800毫秒
				$('html,body').animate({
					scrollTop: document.getElementById(len).offsetTop - 50
				}, 800); //点击按钮向下移动800px，时间为800毫秒

				// document.getElementById(len).scrollIntoView();
			},
			getServicesInfo(themeId) {
				var that = this;
				axios.get(APPCONFIG.GetServicesUrl + '?pagesize=10&pageindex=1&specCode=' + themeId).then(function(e) {
					if (e.data && e.data.resultInfo) {
						that.servicesInfos = e.data.resultInfo.data.items;
						if (that.servicesInfos.length > 4) that.servicesInfos.length = 4;
					}
				});
			},
			returnStyle(url) {
				return 'background: url(' + url + ') no-repeat';
			},
			logout() {
				let url = this.userInfo ? casLogout + '?userid=' + this.userInfo.pkid : casLogout;
				window.location.href = url;
			},
			loginHelp() {
				let url = window.location + 'help';
				window.location.href = url;
			},
			createArr(pkid, fun) {
				let that = this;
				axios.get(APPCONFIG.GetNewMoudleUrl + '/' + pkid + '.json').then(function(e) {
					if (e.data.resultInfo && e.data.resultInfo.data && e.data.resultInfo.data.items) {
						let themes = e.data.resultInfo.data.items;
						themes.forEach((item, index) => {
							let obj = {};
							obj.url = item.descinfo;
							obj.name = item.nttitle;
							obj.imgUrl = host + item.imageurl;
							obj.content = item.ntcontent;
							fun(obj);
						});
					}
				});
			},
			checkpermis(name) {
				let that = this;
				axios.get(APPCONFIG.IP + "/skygeoesbmengine/services/module/permis/" + this.userid + ".json").then(function(e) {

					if (e.data.data.modules && e.data.data.modules[0] && e.data.data.modules[0].children) {
						that.permisArray = e.data.data.modules[0].children;
					}
				});


			},
			animate() {
				let target = document.getElementById("cardContainer");
				let distance = target.children.length * 340;
				let moved = 0;
				const step = 340;
				const time = setInterval(() => {
					const left = parseInt(target.style.left) || 0;
					if (moved != 0 && (moved % distance) == 0) {
						moved = 0;
						$("#cardContainer").animate({
							left: '0px',
						});
					} else {
						moved += step;
						$("#cardContainer").append(target.children[0]);
					}
				}, 3000)
			}

			//获取用户信息
			,
			getUserInfo() {
				let that = this;
				//获取当前登录状态
				axios.get(APPCONFIG.GetUserInfoUrl).then(function(e) {
					//console.log(e);
					if (e.data) {
						if (typeof(e.data) == "object") {
							if (e.data.resultInfo.data.pkid == '21') {
								that.getMapModule('21');
								return;
							}
							//获取到用户信息
							that.userInfo = e.data.resultInfo.data;
							that.userid = e.data.resultInfo.data.pkid;

							that.username = e.data.resultInfo.data.usershortname;
							that.loginTextShow = false;
							that.getMapModule(that.userid);
							//that.checkpermis();
						} else {
							//获取不到用户信息，则执行匿名登录
							//console.log("获取不到用户信息，则执行匿名登录");
							that.getTicket();
						}
					} else {
						//获取不到用户信息，则执行匿名登录
						that.getTicket();
					}
				});
			}
			//匿名登录获取Ticket
			,
			async getTicket() {
					let res = await getTicket();
					//console.log(res)
					let xml = res.data;
					//console.log(xml)
					var TGT = xml.replace(/.*action=.*\/(.*?)\".*/ig, "$1");
					//console.log(TGT);

					//关键步骤1：使用申请到的TGT为不同的站点申请ST(票据)
					let serviceGEO = APPCONFIG.GetUserInfoUrl;
					let res1 = await getServiceTicketGeoesbengine(TGT);
					let ST = res1.data;
					//console.log(ST);

					//使用ST
					let res2 = await getServiceCall(serviceGEO, ST);
					//console.log(res2);
					//关键步骤2：将当前TGT保存至本域的COOKIE中，用于删除操作
					Cookies.set("CASTGCTMP", TGT);

					this.getMapModule('21');
					//this.checkpermis();
				}
				//登录按钮事件
				,
			async userLogin() {
					//先退出登录
					// let casTGC = Cookies.get("CASTGCTMP");
					// let deleteRes = await deleteTGT(casTGC);
					// Cookies.remove("CASTGCTMP");
					let logoutUrl = APPCONFIG.IP + "/skycas/logout";
					let loginPage = APPCONFIG.IP + "/skycas/login";
					//let navPage = APPCONFIG.IP + "/nav";
					//let url = loginPage + "?service=" +encodeURIComponent(navPage+"?r="+Math.random());
					window.location.href = logoutUrl+"?service="+ loginPage;
				}
				//注册事件
				,
			async userRegister() {
				let logoutUrl = APPCONFIG.IP + "/skycas/logout";
				let RegisterPage = APPCONFIG.IP + "/usercenter/static/register/register.html";
				let url = logoutUrl + "?service=" + encodeURIComponent(RegisterPage + "?r=" + Math.random());
				window.location.href = url;
			}

		},
		mounted() {
			let that = this;
			//this.animate();
			this.getUserInfo();
			this.getServicesInfo(dataThemesConfig[0].theme);

			$('#J-ali-main-specail li').hover(
				function() {
					$(this)
						.removeClass()
						.addClass('hover');
				},
				function() {
					$(this).removeClass();
				}
			);
			$('.cloud1').on('click', function() {
				//_self.common.scroll('#cloud', 1000);
				window.open('/map', '_blank');
			});
			axios.get(APPCONFIG.GetNewsUrl).then(function(e) {
				if (e.data.resultInfo && e.data.resultInfo.data && e.data.resultInfo.data.items) {
					let newsmoudels = e.data.resultInfo.data.items;
					newsmoudels.forEach((item, index) => {
						if (item.name == '典型应用') {
							// that.Themes4 = [];
							// that.createArr(item.pkid, function(obj) {
							// 	that.Themes4.push(obj);
							// });
							that.duijieyingyong = [];
							that.createArr(item.pkid, function(obj) {
								that.duijieyingyong.push(obj);
							});
						} else if (item.name == '特色应用') {
							that.Themes3 = [];
							that.createArr(item.pkid, function(obj) {
								that.Themes3.push(obj);
							});
						} else if (item.name == '平台应用服务') {
							that.Themes2 = [];
							that.createArr(item.pkid, function(obj) {
								that.Themes2.push(obj);
							});

						}
					});
				}
			});
			// setTimeout(() => {
			// 	that.animate();
			// }, 1000);

		}
	};
</script>
<style type="text/css">
	.imgConac {
		float:left;
		z-index: 999;
		width:10%;
		display: inline-block;
		position: relative;
		left: 615px;
		top: 11px;
	}

	#last span {
		margin-left: 20px;
		font-size: 13px;
	}

	.card_text {
		color: white;
		width: 100%;
		background-color: rgba(135, 153, 163, 0.5);
		display: block;
		padding: 15px;
		font-size: 25px;
		position: absolute;
		left: 0px;
		bottom: 40px;
	}

	.nav_3_img .mu-card-header-title .mu-card-title {
		font-size: 20px;
	}

	.media-body h4 {
		font-size: 18px;
	}

	.media-body p {
		font-size: 14px;
	}

	/* navigation
-------------------------------------------------- */
	.navigation .ali-main-special {
		position: relative;
		width: 100%;
		height: 120px;
		padding: 0px;
		margin: 30px 0;
		text-align: right;
	}

	.navigation .ali-main-special .media {
		cursor: pointer;
	}

	.case {
		float: left;
		width: 32%;

		margin-top: 2%;
	}

	.case .mu-item {

		padding-bottom: 15px;
	}

	.case .mu-item-content {
		background: #286fab;
		padding: 1px;
	}

	.dianxing {
		float: right;

		margin-top: 3%;
		margin-bottom: 3%;
	}

	.navigation .ali-main-special li {
		position: relative;
		height: 120px;
		display: block;
		width: 20%;
		float: left;
	}

	.navigation .ali-main-special .hover h4 {
		color: #004d8c;
	}

	.navigation .ali-main-special li:before,
	.navigation .ali-main-special li:after {
		content: '';
		position: absolute;
		width: 1px;
		height: 100%;
		background: #d8d8d8;
		top: 0;
		z-index: 2;
	}

	.navigation .ali-main-special li:before {
		left: 0;
		margin-left: -1px;
	}

	.navigation .ali-main-special li:after {
		right: 0;
	}

	.navigation .ali-main-special li a {
		padding: 0 1px;
		display: block;
		width: 100%;
		height: 100%;
	}

	.navigation .ali-main-special li .bg-item {
		-webkit-transition: all 0.3s;
		-moz-transition: all 0.3s;
		-o-transition: all 0.3s;
		transition: all 0.3s;
		position: absolute;
		top: -17px;
		left: 6px;
	}

	.navigation .ali-main-special li .bg-normal {
		width: 100%;
		opacity: 1;
		-ms-filter: 'progid:DXImageTransform.Microsoft.Alpha(Opacity=100)';
	}

	.navigation .ali-main-special li .bg-hover {
		width: 100%;
		opacity: 0;
		-ms-filter: 'progid:DXImageTransform.Microsoft.Alpha(Opacity=0)';
	}

	.navigation .ali-main-special li.hover .bg-normal {
		opacity: 0;
		-ms-filter: 'progid:DXImageTransform.Microsoft.Alpha(Opacity=0)';
	}

	.navigation .ali-main-special li.hover .bg-hover {
		opacity: 1;
		-ms-filter: 'progid:DXImageTransform.Microsoft.Alpha(Opacity=100)';
	}

	.navigation .media-body {
		padding-left: 120px;
		text-align: left;
		padding-top: 25px;
	}

	.navigation .media-body a {
		color: rgb(34, 34, 34);
	}

	/*--------------------------------------------------------------------*/
	.mu-tab-active {
		color: red !important;
	}

	body {
		min-width: 1910px;
		overflow-x: auto !important;
	}

	.user-detail span {
		cursor: pointer;
	}

	.card-back-url {
		padding: 10px;
	}

	#app .foot div .footHrefOuter .footHref3 {
		text-align: center;
		height: 30px;
		line-height: 30px;
	}

	.erweima {
		margin-top: 25px;
		padding: 10px 10px 10px 0;
	}

	.liaojiedesc {
		margin-top: 25px;
		background-color: #ffcd74;
		width: 130px;
		text-align: center;
		color: #fff;
		cursor: pointer;
		font-size: 24px;
		font-weight: 900;
		border-radius: 5px;
		box-shadow: 0 0 5px 5px #888888;
	}

	.mu-card-header {
		cursor: pointer;
	}

	.textdesc ul li {
		color: #fff;
		font-size: 18px;
		padding: 8px;
	}

	.textdesc h5 {
		font-size: 20px;
		color: #fff;
	}

	.textdesc {
		margin-top: 50px;
	}

	.finger {
		background: url(/static/img/finger.png) no-repeat;
		height: 532px;
	}

	.phone-title {
		text-align: center;
		font-weight: 900;
		font-size: 25px;
		color: #fff;
		height: 80px;
		line-height: 100px;
		border-bottom: 5px solid #fff;
	}

	.phone-background {
		width: 100%;
		height: 637px;
		min-height: 637px;
		background: url(/static/img/phoneback2.png) no-repeat;
		background-size: cover;
		margin-top: 50px;
	}

	.el-divider__text {
		font-size: 25px !important;
		font-weight: 900 !important;
		color: #ff5a69 !important;
		font-family: inherit !important;
		font-weight: 500 !important;
		line-height: 1.1 !important;
	}

	.sys_pingtai {
		height: 265px;
		padding: 20px 0;
		margin-top: 10px;
	}

	.el-input-group__append {
		border-left: 1px solid #dcdfe6 !important;
		background-color: #5099ea !important;
		color: #fff !important;
		border-radius: 25px !important;
		padding: 0 5px !important;
	}

	#nav_col_img .mu-card-header-title {
		vertical-align: inherit;
	}

	/*#dzdt-icon :hover img{
  cursor: pointer;
  content: url('/static/img/0_0.png');
}
#jcsj-icon :hover img{
 cursor: pointer;
 content: url('/static/img/1_1.png');
}
#jcgn-icon :hover img{
 cursor: pointer;
 content: url('/static/img/2_2.png');
}
#ptyy-icon :hover img{
 cursor: pointer;
 content: url('/static/img/1_3.png');
}
#sjdt-icon :hover img{
 cursor: pointer;
 content: url('/static/img/4_4.png');
}*/

	.nav_3_img .mu-card-header {
		text-align: center;
	}

	.nav_3_img .mu-card-header .mu-avatar img {
		border-radius: 1%;
	}

	.nav_3_img .mu-card-header .mu-card-header-title {
		padding-right: 18px;
		border-radius: 1%;
		display: block;
		text-align: center;
	}

	.el-input__inner {
		border-radius: 25px !important;
		height: 30px !important;
		line-height: 30px !important;
	}

	.mu-card-header-title .mu-card-title {
		font-size: 18px;
	}

	.mu-tab-link-highlight {
		border-radius: 25px;
		height: 3px;
		/* background-color: #fff;*/
	}
</style>
<style scoped>
	.mu-tab-link {
		border-bottom: 3px rgba(0, 0, 0, 0) solid;
	}

	.mu-tab-link:hover {
		border-bottom: 3px red solid;
		transition: transform 0.3s, opacity 0.3s;
	}

	#nav_4_img .mu-card-header .mu-avatar img {
		border-radius: 1%;
	}

	#nav_col_img .mu-card-header .mu-avatar img {
		border-radius: 20%;
		width: 50px;
		height: 50px;
	}

	.el-button {
		color: #fff;
		border-radius: 25px;
	}

	.el-input {
		padding: 5px;
		width: 98%;
		/*background-color: #7572728a;
    border: 1px solid #8c7e7e;*/
		border-radius: 25px;
		caret-color: #fff;
	}

	.sys_title {
		background: url('/static/img/top-pic.png') no-repeat center top;

		height: 95px;
		margin-top: 20px;
	}

	.username {
		float: left;
	}

	.bar-name {
		color: white;
	}

	.row-left {
		border-right: 1px dashed rgba(0, 0, 0, 0.1);
	}

	.menu-active {
		border-left: 2px solid lightblue;
	}

	.board-left,
	.board-right {
		padding: 5px;
	}

	.paper-draft {
		padding: 10px;
	}

	.list-menu {
		background: #eeeeee;
	}

	.sys_header,
	.header_user {
		background-color: #fff;
		color: #4e2594;
		height: 78px;
	}

	.sys_header .mu-paper-1 {
		box-shadow: none;
		line-height: 32px;
	}

	.sys_header .mu-tab-active {
		color: #333;
	}

	.sys_header .mu-tab-link {
		color: rgba(12, 67, 95, 0.7);
	}

	.sys_header_tabs {
		width: 50%;
	}

	.sys_banner {
		height: 54vh;

		background-color: #83aedb;
		text-align: center;
	}

	.sys_banner img {
		height: 100%;
	}

	.banner_nav {
		height: 60px;
		font-size: 33px;
	}

	.banner_bottom {
		margin-top: -10px;
		background-color: #83aedb;
	}

	.head_sub_nav {
		background-color: #fff;
		padding: 4px auto;
	}

	.left {
		flaot: left;
	}

	.main_nav {
		height: 50px;
		font-size: 20px;
		background-color: #5099ea;
	}

	.main_nav .mu-tab-text {
		color: #fff;
	}

	.banner_nav_col {
		padding: 20px 0px;
	}

	.service_nav {
		background-color: #fff;
		color: #4e2594;
	}

	.service_nav .mu-tab-link {
		color: #666;
	}

	.main_nav .mu-tab-link {
		font-size: 16px;
	}

	.service_tabs_content.mu-paper-1,
	.no_shadow {
		background-color: rgba(0, 0, 0, 0) !important;
		box-shadow: none;
		line-height: 32px;
	}

	.service_tabs_content.mu-paper-1 .service_item {
		width: 20%;
		float: left;
		cursor: pointer;
		margin: 0 2.5%;
	}

	.service_tabs_content.mu-paper-1 .service_item:hover {
		width: 20%;
		float: left;
		cursor: pointer;

		height: 95%;
		margin: 0 2.5%;
		margin-top: -2px;
		box-shadow: 0 10px 10px 10px #888888;
	}

	.bg_h {
		padding: 20px 0px;
		/*  background-color: #fff*/
	}
	.a_v {
		color: #333; /* 默认颜色 */
		display: inline-block;  line-height: 20px; height: 20px;
	}

	.a_v:hover{
		color: rgb(28, 30, 167); /* 鼠标悬停或获得焦点时的颜色 */
	}	
</style>



// WEBPACK FOOTER //
// nav.vue?11ce97c0